<mat-paginator
  [length]="length"
  [pageIndex]="page"
  [pageSize]="pageSize"
  [pageSizeOptions]="[5, 10, 25, 100]"
  (page)="emitValues($event)"
  showFirstLastButtons
></mat-paginator>
